import React from 'react';
import {classes, style, vars} from './doppe-page-profile-picture-media-view.st.css';
import {
    colorResolveLegibleForegroundColor,
    enumIsEnumValue,
    enumValueOrDefault,
    evaluateFunction,
    HtmlObjectHorizontalPosition,
    HtmlObjectResizeMode,
    HtmlObjectVerticalPosition
} from '@wix/devzai-utils-common';
import {DoppePageMediaView} from "../doppe-page-media-view/doppe-page-media-view";
import {doppeColorPaletteResolveColor, DoppePaletteColorType, useBymoPageContextProps} from "../../doppe-sdk";
import {
    doppePageMediaAutoSourceResolve,
    DoppePageProfilePictureSource,
    useBymoPageProps
} from "../../client-server-common";
import {
    BymoPageMediaMaskingShape,
    BymoPageMediaMaskingStandardShape,
    BymoPageMediaMaskingSvgShape
} from "../../client-server-common/bymo-pages/bymo-page-media-masking-shape/bymo-page-media-masking-shape";
import {
    bymoPageMediaMaskingSvgShapeGetCssImageUrl
} from "../bymo-page-media-masking-shape-client-utils/bymo-page-media-masking-shape-client-utils";

const MaskingShapeCssState = {
    Svg: 'svg',
    Circle: 'circle',
    Square: 'square',
}

export const DoppePageProfilePictureMediaView = React.memo(function DoppePageProfilePictureMediaView(
    props: DoppePageProfilePictureMediaView.Props
) {

    const {
        profilePicture,
        layoutSpec,
        widthSpec,
        maskingShape,

        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    const bymoPageProps = useBymoPageProps();
    const bymoPageContextProps = useBymoPageContextProps();

    const resolvedProfilePicture = doppePageMediaAutoSourceResolve(profilePicture, {
        accountProfilePicture: bymoPageContextProps.userProfilePicture
    });

    return (
        <DoppePageMediaView
            {...htmlAttributes}
            className={style(classes.root, {
                maskingShape: evaluateFunction(() => {
                    const normalizedMaskingShape = enumValueOrDefault(
                        BymoPageMediaMaskingShape,
                        maskingShape,
                        BymoPageMediaMaskingStandardShape.Circle
                    );

                    if (enumIsEnumValue(BymoPageMediaMaskingSvgShape, normalizedMaskingShape)) {
                        return MaskingShapeCssState.Svg;
                    } else {
                        switch (normalizedMaskingShape) {
                            case BymoPageMediaMaskingStandardShape.Circle: {
                                return MaskingShapeCssState.Circle;
                            }
                            case BymoPageMediaMaskingStandardShape.Square: {
                                return MaskingShapeCssState.Square;
                            }
                        }
                    }
                })
            }, className)}
            mediaResource={resolvedProfilePicture}
            layoutSpec={layoutSpec}
            widthSpec={widthSpec}
            style={{
                ...styleProp,
                [vars.mask]: enumIsEnumValue(BymoPageMediaMaskingSvgShape, maskingShape) ?
                    bymoPageMediaMaskingSvgShapeGetCssImageUrl(maskingShape) :
                    undefined,
            }}
            innerClassName={classes.mask}
            mediaResizeMode={HtmlObjectResizeMode.Cover}
            mediaVerticalPosition={HtmlObjectVerticalPosition.Center}
            mediaHorizontalPosition={HtmlObjectHorizontalPosition.Center}
            videoMuted={true}
            autoPlayVideo={true}
            playVideoInLoop={true}
            emptyMediaPlaceholder={(
                <div
                    className={style(
                        classes.defaultAvatarBackground,
                        {
                            mainColorBackground: evaluateFunction(() => {
                                return colorResolveLegibleForegroundColor(
                                    doppeColorPaletteResolveColor(bymoPageProps.colorPalette, DoppePaletteColorType.Main)
                                ) === 'white'
                            })
                        },
                        className
                    )}
                >
                    <svg
                        width="89"
                        height="89"
                        viewBox="0 0 89 89"
                        xmlns="http://www.w3.org/2000/svg"
                        {...htmlAttributes}
                        className={style(classes.avatarSvg)}
                        // style={{
                        //     opacity: mainColor === 'black' ? '0.4' : '0.95'
                        // }}
                    >
                        <path
                            d="M44.4999 67.4919C33.9853 67.4919 24.5268 72.1147 17.7999 79.4935C18.3844 79.9193 18.9784 80.3309 19.5814 80.7284C26.7978 85.4921 35.3374 88.2586 44.4999 88.2586C53.6625 88.2586 62.202 85.4921 69.4184 80.7284C70.0214 80.3301 70.6162 79.9185 71.1999 79.4935C64.4723 72.1147 55.0138 67.4919 44.4999 67.4919Z"
                            fill={"#FFFFFF"}
                        />
                        <path
                            d="M37.3223 70.0247C37.8392 72.8067 40.9001 74.9405 44.5001 74.9405C48.1076 74.9405 51.1699 72.797 51.6772 70.0069V65.2432H37.3223V70.0247Z"
                            fill={"#EFF1F2"}
                        />
                        <path
                            d="M66.0474 47.9405V47.4911V39.2178C66.0474 27.119 56.1357 17.2192 44.0214 17.2192C32.4336 17.2192 22.9528 26.6873 22.9528 38.2618V47.4911V47.9405C22.4389 48.6303 22.1237 49.475 22.1237 50.3969C22.1237 52.6746 23.9889 54.5399 26.2673 54.5399H26.8481H27.2701C28.3381 63.0957 35.6561 69.7871 44.4997 69.7871C53.3434 69.7871 60.6607 63.0957 61.7301 54.5399H62.7321C65.0113 54.5399 66.8758 52.6746 66.8758 50.3969C66.8758 49.475 66.5606 48.6303 66.0474 47.9405Z"
                            fill={"#FFFFFF"}
                        />
                        <path
                            d="M32.7296 45.9394C40.3153 45.9394 47.7164 42.2703 51.134 36.4876C46.799 40.0031 41.2802 42.1161 35.2638 42.1161H28.7097V45.9394H32.7296Z"
                            fill={"#EFF1F2"}
                        />
                    </svg>
                </div>
            )}
        />
    )
});

export namespace DoppePageProfilePictureMediaView {

    export interface Props extends Pick<DoppePageMediaView.Props, keyof React.HTMLAttributes<any> | 'layoutSpec' | 'widthSpec'> {
        profilePicture: DoppePageProfilePictureSource;
        maskingShape: BymoPageMediaMaskingShape;
    }
}
